import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import Logo from './Logo';
import LanguageSwitcher from './LanguageSwitcher';
import './Navbar.css';

const Navbar = () => {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: t('navbar.home') },
    { path: '/about', label: t('navbar.about') },
    { path: '/services', label: t('navbar.services') },
    { path: '/why-us', label: t('navbar.whyUs') },
    { path: '/gem', label: t('navbar.gem') },
    { path: '/order', label: t('navbar.order') },
    { path: '/contact', label: t('navbar.contact') },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        <Link to="/" className="navbar__logo">
          <Logo size={42} />
        </Link>

        <div className="navbar__right">
          <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
            {navLinks.map(({ path, label }) => (
              <li key={path}>
                <Link
                  to={path}
                  className={`navbar__link ${location.pathname === path ? 'navbar__link--active' : ''} ${path === '/gem' ? 'navbar__link--gem' : ''}`}
                >
                  {label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/order" className="btn btn-green navbar__cta">
                {t('navbar.getFreeQuote')}
              </Link>
            </li>
            <li className="navbar__lang-mobile">
              <LanguageSwitcher />
            </li>
          </ul>

          <div className="navbar__actions">
            <LanguageSwitcher />
            <button
              className={`navbar__burger ${menuOpen ? 'navbar__burger--open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
